import { message } from 'antd';
import { parsePostError, post } from '../utils/ApiUtil';
import type { LoginResultDTO, PhoneLoginParamDTO, SendVerificationCodeParamDTO } from './LoginType';

const mock = false;

export const LoginApi = {
  async login(phone: string, code: string): Promise<LoginResultDTO | null> {
    if (mock && false) {
      return null;
    }
    const param: PhoneLoginParamDTO = { phone, code };
    const result = await post<PhoneLoginParamDTO, LoginResultDTO>('/sparrowUser/login', param);
    if (typeof result === 'string') {
      message.error(parsePostError(result));
      return null;
    }
    return result;
  },

  async sendVerificationCode(phone: string, captchaToken?: string): Promise<boolean> {
    if (mock && false) {
      return true;
    }
    const param: SendVerificationCodeParamDTO = {
      phone,
      ...(captchaToken ? { captchaToken } : {}),
    };
    const result = await post<SendVerificationCodeParamDTO, boolean>('/sparrowUser/sendVerificationCode', param);
    if (typeof result === 'string') {
      message.error(parsePostError(result));
      return false;
    }
    return !!result;
  },
};
